import { render, staticRenderFns } from "./SingleCourse.vue?vue&type=template&id=50c8ee62&scoped=true&"
import script from "./SingleCourse.vue?vue&type=script&lang=js&"
export * from "./SingleCourse.vue?vue&type=script&lang=js&"
import style0 from "./SingleCourse.vue?vue&type=style&index=0&id=50c8ee62&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c8ee62",
  null
  
)

export default component.exports